import {default as BaseAutocompleteController} from '../lib/autocomplete-controller'

export default class extends BaseAutocompleteController {
}